import { type App, type Ref, createApp, ref, watch } from "vue";
// eslint-disable-next-line @typescript-eslint/naming-convention
import { DsModalVideoProps } from "./ds-modal-video-props";
import DsModalVideo from "./ds-modal-video.vue";
import { Theme } from "../types/theme";

let isGlobalVideoModalInitialized = false;

/**
 * Mount DS video component
 * @param videoCodeOrUrl - Youtube Video code or URL of the video on any platform
 * @param modelValue - Handles showing / hiding modal
 * @param theme - Theme - Design system theme
 * @param cssClass - Custom class for your css
 */
export function showModalVideo(props: DsModalVideoProps) {
    const modalRef: Ref<App | null> = ref(null);
    const isVisible = ref(true);

    modalRef.value = createApp(DsModalVideo, { ...props });

    const root = document.createElement("div");
    modalRef.value.mount(root);

    watch(isVisible, (newVal) => {
        if (!newVal && modalRef.value) {
            modalRef.value.unmount();
        }
    });

    return {
        isVisible,
    };
}

export function useGlobalVideoModal() {
    if (isGlobalVideoModalInitialized) return;
    isGlobalVideoModalInitialized = true;

    document.addEventListener("click", (e: Event) => {
        const button = (e.target as HTMLElement).closest<HTMLElement>(".btn-video");
        if (!button) return;

        e.preventDefault();

        let theme = button.getAttribute("data-theme") as Theme;
        let url = button.getAttribute("data-video-codes");
        const isYoutubeShort = button.dataset.isYtbShort === "True";

        if (!theme) theme = "light";
        if (!url) url = button.getAttribute("href");
        if (!url) return;

        showModalVideo({
            videoCodeOrUrl: url,
            modelValue: true,
            theme: theme,
            isYoutubeShort: isYoutubeShort,
        });
    });
}
